<div mat-dialog-title class="title">
    <mat-icon fontIcon="description"></mat-icon>
    {{ report.type }}
</div>

<mat-dialog-content>
    <p>{{'datatable.createdDate'|translate}} : {{report.createdDate}}</p>
    <p>{{'datatable.devices'|translate}} : {{report.successDevices}}/{{report.logs?.length || 0}}</p>

    <!-- "One by one" mode (see unifield-mobile-2's list-update-kyds.page.ts) never sends a
    single shared minDistance at all - report.settings itself is still a truthy object
    regardless (its OTHER sub-fields all have schema defaults, see unifield-api-v3's
    model/other/report.js), so checking minDistance specifically is the only reliable way to
    tell "no shared config, every device has its own" apart from a genuine "same config for
    all" report. -->
    <ng-container *ngIf="report.settings?.minDistance != null">
        <h4>{{'trackers.settings_applied'|translate}}</h4>

        <p>{{'trackers.selfAlertDistance'|translate}} : {{(report.settings.minDistance / 100).toFixed(2)}} m</p>

        <ng-container *ngIf="report.settings.userMode == 'advanced' && report.settings.isCheckedKey">
            <p>{{'trackers.friendGroup'|translate}} : {{report.settings.friendGroup}}</p>
            <p>{{'trackers.ignoreGroup'|translate}} : {{report.settings.ignoreGroup}}</p>
            <p>{{'trackers.unfriendDistanceLabel'|translate}} : {{(report.settings.maxDistance / 100).toFixed(2)}} m</p>
            <p *ngIf="report.settings.friendGroup === 99 && report.settings.exclusionDistance != null">{{'trackers.exclusionDistanceLabel'|translate}} : {{(report.settings.exclusionDistance / 100).toFixed(2)}} m</p>
        </ng-container>
    </ng-container>

    <h4>{{'datatable.type'|translate}} - {{'trackers.title'|translate}}</h4>
    <mat-list>
        <ng-container *ngFor="let log of report.logs">
            <mat-list-item>
                <mat-icon matListItemIcon
                    [color]="logOutcome(log) === 'ok' ? 'primary' : (logOutcome(log) === 'skipped' ? '' : 'warn')">
                    {{ logOutcome(log) === 'ok' ? 'check_circle' : (logOutcome(log) === 'skipped' ? 'bluetooth_disabled' : 'error') }}
                </mat-icon>
                <div matListItemTitle>{{ log.tracker }}</div>
                <div matListItemLine>{{ log.status }} - {{'datatable.retries'|translate}} : {{ log.retry }}</div>
            </mat-list-item>

            <!-- Only ever present for a device actually configured by "one by one" mode (see
            unifield-mobile-2's list-update-kyds.page.ts's connect()) - "same config for all"
            already shows its one shared config once above instead of repeating it per device.
            Deliberately NOT inside the mat-list-item above (as matListItemLine content) - MDC
            list items clamp every "line" to a single row (overflow: hidden + ellipsis) and only
            budget room for a couple of them, which otherwise silently cut this off after the
            first field or two regardless of how the text was split across lines. -->
            <div class="applied-settings" *ngIf="log.appliedSettings as settings">
                <span *ngIf="appliedConfigName(log)">
                    {{'menu.devices.configs.applied_template'|translate}} : {{appliedConfigName(log)}}
                </span>
                <span *ngIf="settings.unfriendDistance != null">
                    {{'trackers.unfriendDistanceLabel'|translate}} : {{formatCm(settings.unfriendDistance)}} m
                </span>
                <span *ngIf="settings.friendGroup === 99 && settings.exclusionDistance != null">
                    {{'trackers.exclusionDistanceLabel'|translate}} : {{formatCm(settings.exclusionDistance)}} m
                </span>
                <ng-container *ngIf="settings.userMode == 'advanced'">
                    <span *ngIf="settings.minDistance != null">
                        {{'trackers.selfAlertDistance'|translate}} : {{formatCm(settings.minDistance)}} m
                    </span>
                    <span *ngIf="settings.maxDistance != null">
                        {{'trackers.otherAlertDistance'|translate}} : {{formatCm(settings.maxDistance)}} m
                    </span>
                    <span *ngIf="settings.friendGroup != null">
                        {{'trackers.friendGroup'|translate}} : {{settings.friendGroup}}
                    </span>
                    <span *ngIf="settings.ignoreGroup != null">
                        {{'trackers.ignoreGroup'|translate}} : {{settings.ignoreGroup}}
                    </span>
                </ng-container>
            </div>
        </ng-container>
    </mat-list>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <lib-button (click)="close()" text="{{'form.close'|translate}}" color="outline" icon="close"></lib-button>
</mat-dialog-actions>
